import clsx from "classnames";
import { Button, Container } from "react-bootstrap";
import classes from "./styles.module.scss";
import { DynamicText } from "@/components/DynamicText";
import image from "./image.png";

export const GenericCTA = ({ className, title, text, button }) => {
  return (
    <div
      className={clsx(className, classes.cta)}
      style={{ backgroundImage: `url(${image?.url})` }}
    >
      <div className={classes.cta__content}>
        <Container fluid="lg" className="py-5 py-md-6">
          <h2 className="mb-4" data-sourceflow-prop="title">
            {typeof title === "object" && "placeholder" in title ? (
              <DynamicText
                dangerouslySetInnerHTML={{ __html: title.placeholder }}
              />
            ) : (
              <span dangerouslySetInnerHTML={{ __html: title }} />
            )}
          </h2>
          <p className="mb-5" data-sourceflow-prop="text">
            {typeof text === "object" && "placeholder" in text ? (
              <DynamicText
                dangerouslySetInnerHTML={{ __html: text.placeholder }}
              />
            ) : (
              <span dangerouslySetInnerHTML={{ __html: text }} />
            )}
          </p>
          <Button
            href={button.href}
            variant="blue"
            data-sourceflow-prop="button"
          >
            {typeof button.label === "object" && "placeholder" in button.label ? (
              <DynamicText
                dangerouslySetInnerHTML={{ __html: button.label.placeholder }}
              />
            ) : (
              <span dangerouslySetInnerHTML={{ __html: button.label }} />
            )}
          </Button>
        </Container>
      </div>
    </div>
  );
};

export default GenericCTA;
